module.exports = __webpack_public_path__ + "img/underframe.52e02413.png";